var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplacementscreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86 14.365c.724.483 1.685.6 2.997.633h.023a.937.937 0 0 0 .024-1.875c-1.11-.026-1.708-.122-2.001-.316a1.88 1.88 0 0 1-.518-.518c-.195-.293-.29-.89-.317-2.001a.928.928 0 0 0-.958-.914.934.934 0 0 0-.914.958c.03 1.315.148 2.273.633 2.997.274.413.623.76 1.033 1.034l-.002.002z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86 14.365c.724.483 1.685.6 2.997.633h.023a.937.937 0 0 0 .024-1.875c-1.11-.026-1.708-.122-2.001-.316a1.88 1.88 0 0 1-.518-.518c-.195-.293-.29-.89-.317-2.001a.928.928 0 0 0-.958-.914.934.934 0 0 0-.914.958c.03 1.315.148 2.273.633 2.997.274.413.623.76 1.033 1.034l-.002.002z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11 5.625h.024a.937.937 0 0 0 .937-.917c.026-1.11.122-1.708.317-2 .138-.207.311-.38.517-.519.293-.194.89-.29 2.002-.316A.935.935 0 0 0 5.82.914a.93.93 0 0 0-.959-.913C3.548.03 2.59.148 1.865.63c-.41.274-.76.623-1.036 1.036C.347 2.39.23 3.352.2 4.664a.937.937 0 0 0 .914.958l-.002.003z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11 5.625h.024a.937.937 0 0 0 .937-.917c.026-1.11.122-1.708.317-2 .138-.207.311-.38.517-.519.293-.194.89-.29 2.002-.316A.935.935 0 0 0 5.82.914a.93.93 0 0 0-.959-.913C3.548.03 2.59.148 1.865.63c-.41.274-.76.623-1.036 1.036C.347 2.39.23 3.352.2 4.664a.937.937 0 0 0 .914.958l-.002.003z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.559 1.667A3.708 3.708 0 0 0 13.525.633c-.723-.482-1.684-.6-2.997-.63a.937.937 0 0 0-.044 1.872c1.11.026 1.708.122 2.001.317.206.138.38.311.518.517.194.293.29.89.316 2.002.012.51.43.916.938.916h.023a.934.934 0 0 0 .914-.959c-.03-1.314-.148-2.273-.633-2.997l-.002-.004z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.559 1.667A3.708 3.708 0 0 0 13.525.633c-.723-.482-1.684-.6-2.997-.63a.937.937 0 0 0-.044 1.872c1.11.026 1.708.122 2.001.317.206.138.38.311.518.517.194.293.29.89.316 2.002.012.51.43.916.938.916h.023a.934.934 0 0 0 .914-.959c-.03-1.314-.148-2.273-.633-2.997l-.002-.004z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.505 14.998h.024c1.314-.03 2.273-.148 2.997-.633.412-.274.759-.623 1.035-1.033.483-.725.6-1.685.63-2.998a.937.937 0 0 0-1.872-.044c-.025 1.11-.121 1.708-.316 2.001a1.88 1.88 0 0 1-.518.518c-.293.195-.89.29-2 .316A.937.937 0 0 0 10.507 15l-.003-.002z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.505 14.998h.024c1.314-.03 2.273-.148 2.997-.633.412-.274.759-.623 1.035-1.033.483-.725.6-1.685.63-2.998a.937.937 0 0 0-1.872-.044c-.025 1.11-.121 1.708-.316 2.001a1.88 1.88 0 0 1-.518.518c-.293.195-.89.29-2 .316A.937.937 0 0 0 10.507 15l-.003-.002z",
    fill: "#000",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementscreen);
export default __webpack_public_path__ + "static/media/replacementscreen.5196438404b0c02b0c1334e89144636c.svg";
export { ForwardRef as ReactComponent };